import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  TextField,
  Alert,
  Snackbar,
  createSvgIcon,
  Typography,
  Divider,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@emotion/react";
import useStyle from "./styles";
import loginImg from "../../../assets/imgs/login/login.png";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import loginImgWhite from "../../../assets/imgs/login/login.png";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import { ReactComponent as GoogleLogo } from "../../../assets/icons/google.svg";

import {
  Person2Outlined,
  VisibilityOffOutlined,
  VisibilityOutlined,
} from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import InstagramIcon from "@mui/icons-material/Instagram";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import AccountCircle from "@mui/icons-material/AccountCircle";
import LockIcon from "@mui/icons-material/Lock";
import { refreshSystemStatus } from "../../../services/systemStatus";
import api from "../../../services/api";

export default function Login(params) {
  const {
    setAdmPermissao = () => {},
    setRoutesPermissao = () => {},
    buildTreePermissao = () => {},
    checkIsPermission = () => {},
    formatObjectPermissoes = () => {},
  } = params;
  const theme = useTheme();
  const styles = useStyle(theme);
  const GoogleIcon = createSvgIcon(<GoogleLogo />);
  const [showPassword, setShowPassword] = useState(false);
  const [login, setLogin] = useState("");
  const [senha, setSenha] = useState("");
  const isScreenSmall = useMediaQuery(theme.breakpoints.up("lg"));

  const [Null, setNull] = useState(false);
  const [snackbar, setSnackbar] = useState(null);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(false);
  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);
  const [passShrink, setPassShrink] = useState(false);
  const hiddenButtonLogin =
    window?.config?.REACT_APP_HIDDEN_LOGIN_BUTTON ||
    process.env.REACT_APP_HIDDEN_LOGIN_BUTTON ||
    "";

  // limita o keydown no campo senha
  const [enterFlag, setEnterFlag] = useState(false);

  const url = `${
    window?.config?.REACT_APP_BASE_URL || process.env.REACT_APP_BASE_URL || ""
  }`;
  //img background
  const urlLoginImg = `${
    window?.config?.REACT_APP_LOGIN_IMG_INTERNO ||
    process.env.REACT_APP_LOGIN_IMG_INTERNO ||
    ""
  }`;
  //img logo
  const logoInternoDark = `${
    window?.config?.REACT_APP_LOGO_INTERNO_DARK ||
    process.env.REACT_APP_LOGO_INTERNO_DARK ||
    ""
  }`;
  const logoInternoLight = `${
    window?.config?.REACT_APP_LOGO_INTERNO_LIGHT ||
    process.env.REACT_APP_LOGO_INTERNO_LIGHT ||
    ""
  }`;

  //radesociais
  const urlFacebook = `${
    window?.config?.REACT_APP_URL_FACEBOOK ||
    process.env.REACT_APP_URL_FACEBOOK ||
    ""
  }`;
  const urlInstagram = `${
    window?.config?.REACT_APP_URL_INSTAGRAM ||
    process.env.REACT_APP_URL_INSTAGRAM ||
    ""
  }`;
  const urlLinkedin = `${
    window?.config?.REACT_APP_URL_LINKEDIN ||
    process.env.REACT_APP_URL_LINKEDIN ||
    ""
  }`;

  // Redireciona o usuário já autenticado (dados de "user"/"perfil" do localStorage)
  const entrarNoSistema = async (userData, perfil) => {
    // SISTEM_BLOCK: sai antes de checkIsPermission(), que responderia 503
    const { blocked } = await refreshSystemStatus();
    if (blocked) {
      navigate("/interno/resumo");
      return;
    }

    // NECESSÁRIO VERIFICAÇÃO DE PERMISSÕES ANTES DE ENTRAR NO SISTEMA
    const userPermission = await checkIsPermission();

    setAdmPermissao(userPermission?.isAdmin);
    setRoutesPermissao(formatObjectPermissoes(userData?.usuario));
    const treePermissao = buildTreePermissao(
      userData?.usuario?.rlPermissoesUsuario,
    );

    if (
      userData?.usuario?.status == true &&
      userData?.perfilAlreadyExists === true &&
      perfil?.telefone
    ) {
      const initialRoute = userPermission?.isAdmin
        ? "/interno/resumo"
        : treePermissao?.[0]?.children?.length > 0
          ? treePermissao?.[0]?.children?.[0]?.path
          : treePermissao?.[0]?.path;

      navigate(initialRoute);
    } else if (
      userData?.usuario?.status == true &&
      (userData?.perfilAlreadyExists === false || !perfil?.telefone)
    ) {
      navigate("/interno/cadastro");
    } else if (
      userData?.usuario?.status == false &&
      userData?.perfilAlreadyExists === true
    ) {
      setAlert(true);
    }
  };

  // Login automático: se já existe token salvo e ele ainda é válido, entra
  // direto em vez de pedir login de novo. Após o logout o localStorage está
  // vazio, então nada acontece.
  useEffect(() => {
    let userData = null;
    try {
      userData = JSON.parse(localStorage.getItem("user"));
    } catch (error) {}
    if (!userData?.token) return;

    setLoading(true);
    api
      .get("/authenticationToken")
      .then(() =>
        entrarNoSistema(userData, JSON.parse(localStorage.getItem("perfil"))),
      )
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleLogin = async () => {
    if (!login || !senha) {
      setNull(true);
      return;
    }

    setLoading(!login || !senha);
    try {
      const response = await axios.post(
        `${url}/login`,
        { login, senha },
        { withCredentials: false },
      );

      if (response?.data?.token) {
        const { perfil, logs, acessoClienteId, ...userData } = response.data;
        localStorage.clear();
        if (response.data.usuario?.status) {
          localStorage.setItem("user", JSON.stringify(userData));
          if (perfil) localStorage.setItem("perfil", JSON.stringify(perfil));
          localStorage.setItem("logs", JSON.stringify(logs));
        }

        await entrarNoSistema(userData, perfil);
      } else {
        localStorage.clear();

        setSnackbar({
          children: `Erro: senha ou login incorreto`,
          severity: "error",
        });
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        setSnackbar({
          children: `Erro: senha ou login incorreto`,
          severity: "error",
        });
      } else if (error?.response?.status === 429) {
        const dataError = isValidJSON(error?.response?.data?.error)
          ? JSON.parse(error?.response?.data?.error)
          : "";
        setSnackbar({
          children: `Erro: Muitas tentativas incorretas. Por favor aguarde ${
            dataError?.waitingTime || 5
          } minutos`,
          severity: "error",
        });
      } else {
        setSnackbar({
          children: `Falha ao tentar se conectar ao Servidor`,
          severity: "error",
        });
      }
      console.error(error);
    }
    setLoading(false);
  };

  const isValidJSON = (str) => {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  };

  return (
    <Box sx={styles.container}>
      <Box sx={styles.form}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            width: "95%",
            mt: 2,
          }}
        >
          {!hiddenButtonLogin && (
            <Button
              variant="outlined"
              onClick={() => {
                navigate("/login");
              }}
            >
              CLIENTE
            </Button>
          )}
        </Box>
        <Box sx={styles.body}>
          <Box sx={styles.content}>
            <Box sx={styles.logo}>
              <Box sx={styles.boxLogo}>
                <img
                  src={
                    theme.palette.mode == "dark"
                      ? logoInternoDark
                      : logoInternoLight
                  }
                  style={styles.img}
                  alt="logo-empresa"
                />
              </Box>
            </Box>

            <Box sx={styles.containerSubtitle}>
              <Typography sx={{ fontSize: "26px", fontWeight: 400 }}>
                Faça login na sua conta
              </Typography>
              <Box sx={{ display: "flex", gap: 1 }}>
                <Typography
                  sx={{ fontSize: "16px", fontWeight: 400, color: "grey" }}
                >
                  Novo por aqui?
                </Typography>
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: 500,
                    color: theme.palette.tertiary.main,
                  }}
                >
                  Cadastre-se ou Contate-nos
                </Typography>
              </Box>
            </Box>
            <TextField
              id="login"
              variant="filled"
              label="Login"
              size="medium"
              sx={styles.textfield}
              error={!login && Null}
              onChange={(event) => {
                setLogin(event.target.value);
              }}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  event.preventDefault();
                  document.getElementById("password").focus();
                }
              }}
            />

            <TextField
              id="password"
              variant="filled"
              label="Senha"
              size="medium"
              type={showPassword ? "text" : "password"}
              sx={styles.textfield}
              autoComplete="off"
              error={!senha && Null}
              onKeyDown={(event) => {
                if (event.key === "Enter" && !enterFlag) {
                  setEnterFlag(true);
                  handleLogin();
                }
              }}
              onKeyUp={(event) => {
                setEnterFlag(false);
              }}
              onChange={(event) => {
                setSenha(event.target.value);
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      color="disabled"
                      aria-label="toggle password visibility"
                      onClick={() => setShowPassword((show) => !show)}
                      onMouseDown={(event) => {
                        event.preventDefault();
                      }}
                    >
                      {showPassword ? (
                        <VisibilityOffOutlined />
                      ) : (
                        <VisibilityOutlined />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Box sx={styles.boxRecover}>
              <Button
                sx={styles.buttonRecover}
                onClick={() => {
                  navigate("/interno/redefinirSenha");
                }}
              >
                Esqueceu a senha ?
              </Button>
            </Box>
            <Button
              variant="contained"
              sx={styles.button}
              onClick={handleLogin}
              disabled={loading}
            >
              Entrar
            </Button>
          </Box>
        </Box>

        <Divider sx={{ mt: 8 }} variant="fullWidth">
          <Typography sx={{ color: "grey" }}>Redes Sociais</Typography>
        </Divider>
        <Box sx={styles.body}>
          <Box
            sx={{
              ...styles.content,
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <IconButton
              variant="contained"
              size="large"
              disabled={!urlFacebook}
              onClick={() => {
                window.open(`${urlFacebook}`, "_blank");
              }}
            >
              <FacebookOutlinedIcon sx={{ width: 30, height: 30 }} />
            </IconButton>
            <IconButton
              variant="contained"
              size="large"
              disabled={!urlInstagram}
              onClick={() => {
                window.open(`${urlInstagram}`, "_blank");
              }}
            >
              <InstagramIcon
                sx={{
                  width: 30,
                  height: 30,
                }}
              />
            </IconButton>
            <IconButton
              variant="contained"
              size="large"
              disabled={!urlLinkedin}
              onClick={() => {
                window.open(`${urlLinkedin}`, "_blank");
              }}
            >
              <LinkedInIcon sx={{ width: 30, height: 30 }} />
            </IconButton>
          </Box>
        </Box>
      </Box>

      <Box>
        <Box
          component="img"
          src={urlLoginImg}
          alt="login-img"
          sx={{
            ...styles.boxImg,
            width: "60vw",
            backgroundSize: "cover",
            backgroundPosition: "center",
            "@media (min-width: 2200px)": {
              backgroundSize: "cover",
            },
            "@media(max-width: 1200px)": {
              display: "none",
            },
          }}
        />
      </Box>

      <Snackbar
        autoHideDuration={6000}
        open={alert}
        onClose={() => {
          setAlert(false);
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity="error">Usuário desativado</Alert>
      </Snackbar>

      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
    </Box>
  );
}
